// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"492":"d28c5fe1","570":"35f0311c","766":"c544c08e"}[chunkId] + ".css";
};